// src/components/OptionCard.jsx
import React from "react";

export default function OptionsCard({
  mode = "india",
  options = [],
  correctLabel,
  selectedAnswer,
  isCorrect,
  loading,
  onAnswer,
  onNext,
  moreInfoEnabled = false,
  stateInfo,
}) {
  const correctName = correctLabel;

  // Extra info sirf India mode + correct answer + toggle ON
  const showInfo =
    mode === "india" &&
    moreInfoEnabled &&
    isCorrect === true &&
    !!selectedAnswer &&
    !!stateInfo;

  const neighbourCount =
    stateInfo?.neighbours
      ? stateInfo.neighbours
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean).length
      : 0;

  const labelText =
    mode === "passes" ? "Guess the pass / ghat" : "Guess the state";

  const titleText =
    mode === "passes"
      ? "Identify the mountain pass or ghat"
      : "Identify the state or union territory";

  return (
    <div className="options-card">
      <div>
        <div className="options-label">{labelText}</div>
        <h2 className="options-title">{titleText}</h2>

        <div className="options-grid">
          {options.map((opt) => {
            const isSelected = selectedAnswer === opt;
            const isRight = isSelected && isCorrect === true;
            const isWrong = isSelected && isCorrect === false;

            const isCorrectOptionAfterWrong =
              isCorrect === false && opt === correctName;

            const classes = [
              "option-btn",
              isRight && "option-right",
              isWrong && "option-wrong",
              isCorrectOptionAfterWrong && "option-right",
              isSelected && "option-selected",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <button
                key={opt}
                disabled={!!selectedAnswer || loading}
                onClick={() => onAnswer(opt)}
                className={classes}
              >
                {opt}
              </button>
            );
          })}
        </div>

        {showInfo && (
          <div className="state-info-card">
            <div className="state-info-header">
              <span className="state-info-chip">{correctName}</span>
              <span className="state-info-tag">Extra info</span>
            </div>

            <div className="state-info-grid">
              <div className="state-info-item">
                <div className="state-info-label">Capital</div>
                <div className="state-info-value">
                  {stateInfo.capital || "—"}
                </div>
              </div>

              <div className="state-info-item">
                <div className="state-info-label">CM</div>
                <div className="state-info-value">
                  {stateInfo.cm || "—"}
                </div>
              </div>

              <div className="state-info-item">
                <div className="state-info-label">Governor</div>
                <div className="state-info-value">
                  {stateInfo.governor || "—"}
                </div>
              </div>

              <div className="state-info-item">
                <div className="state-info-label">
                  Neighbour states ({neighbourCount})
                </div>
                <div className="state-info-value">
                  {stateInfo.neighbours || "—"}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="footer-row">
        <button onClick={onNext} disabled={loading} className="next-btn">
          {moreInfoEnabled && mode === "india"
            ? "Next →"
            : "Skip / Next →"}
        </button>
      </div>
    </div>
  );
}
